module.exports = __webpack_public_path__ + "static/media/60FA247A-3CAF-4180-BDE6-F11D49CA9CB2.17055217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/60FA247A-3CAF-4180-BDE6-F11D49CA9CB2.jpg
// module id = 300
// module chunks = 0